import { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import Memberships from '../components/Memberships';
import BookingForm from '../components/BookingForm';
import Footer from '../components/Footer';

const Home = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);

  // Attribution: capture ?src=... from URL and persist for the booking POST.
  useEffect(() => {
    const src = new URLSearchParams(window.location.search).get('src');
    if (src) {
      // whitelist to avoid arbitrary values from crawlers
      const allowed = ['email_upsell'];
      if (allowed.includes(src)) {
        localStorage.setItem('pls_attribution', src);
      }
    }
  }, []);

  const handleChoose = (id) => {
    setSelectedPlan({ id, at: Date.now() }); // unique each time so effect re-fires
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <Memberships onChoose={(id) => handleChoose(id)} />
        <BookingForm selectedPlan={selectedPlan?.id} />
      </main>
      <Footer />
    </>
  );
};

export default Home;
